/*-----------------------------------------------------------------
- Cart for Vuex
-----------------------------------------------------------------*/
/* eslint no-shadow: 0 */
const state = {
    myCart: [],
};

const getters = {
    state    : (state) => state,
    myCart   : (state) => state.myCart,
    wareCount: (state) => state.myCart.reduce((previousValue, currentValue) => previousValue + currentValue.count, 0),
};

const mutations = {
    /**
     * Set new myCart
     * 
     * @param {object} state
     * @param {Array} newCart
     */
    updateMyCart(state, newCart) {
        const originalCart = state.myCart;
        newCart.forEach(((n) => {
            const index = originalCart.findIndex((o) => (o.ware_id === n.ware_id) && (o.post_id === n.post_id));
            if (index < 0) {
                originalCart.push(n);
            } else {
                originalCart[index] = n;
            }
        }));
        state.myCart = originalCart;
    },
    
    /**
     * Remove Ware in cart
     * 
     * @param {object} state
     * @param {object} item - ware item
     */
    removeWareItem(state, item) {
        const originalCart = state.myCart;
        const itemIndex = originalCart.findIndex((o) => o.id === item.id);
        originalCart.splice(itemIndex, 1);
        state.myCart = originalCart;
    },
    
    /**
     * Empty cart list
     *
     * @param {object} state
     */
    emptyCart(state) {
        state.myCart = [];
    },
};

const actions = {
    /**
     * Set new myCart
     *
     * @param {commit} commit
     * @param {Array} newCart
     */
    updateMyCart({ commit }, newCart) {
        commit('updateMyCart', newCart);
    },
    
    /**
     * Delete cart item
     *
     * @param {commit} commit
     * @param {object} item
     */
    removeWareItem({ commit }, item) {
        commit('removeWareItem', item);
    },
    
    /**
     * Empty cart list
     *
     * @param {commit} commit
     */
    emptyCart({ commit }) {
        commit('emptyCart');
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
